import ShortLinkView from "./ShortLinkView";
const isLogged = localStorage.getItem("tokenSmarthop") ? true : false;

const config = {
	settings: {
		layout: {
			config: {
				navbar: {
					display: isLogged,
				},
				toolbar: {
					display: isLogged,
				},
				footer: {
					display: false,
				},
				leftSidePanel: {
					display: isLogged,
				},
				rightSidePanel: {
					display: isLogged,
				},
			},
		},
	},
	routes: [
		{
			path: "/sh",
			component: ShortLinkView,
		},
	],
};

export default config;
